import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as Empty } from "assets/svgs/empty.svg";
import { addCartItems } from "actions/cart";
import Loader from "components/loader";
import { trackAddToCart } from "services/analytics";
import { useGlobalContext } from "context/global";

const EmptyCart = () => {
	const { translation, cartSettings } = useGlobalContext();
	const favorites = cartSettings?.favorites?.products;
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	const addFavoriteProducts = async () => {
		if (!favorites) return;
		setLoading(true);
		await dispatch(
			addCartItems(
				favorites
					.filter((product) => ["available", "one-time"].includes(product.variant.stock))
					.map((product) => ({ id: product.variant.id, oneTime: product.variant.stock === "one-time" })
					))
		);
		setLoading(false);
		trackAddToCart(favorites);
	};

	return (
		<div className="relative h-3/4">
			<div className="block text-center pt-10 pb-2.5">
				<Empty className="w-10 h-auto m-auto" />
				<p className="mt-2 text-base">{translation?.cart?.empty_cart}</p>
				{loading ? <Loader ring={true} /> : (
					<button className="cart-action-btn" onClick={addFavoriteProducts}>
						+ {translation?.cart?.add_favorites}
					</button>
				)}
			</div>
		</div>
	);
};

export default EmptyCart;
